<template>
    <div class="copyright-index">
        <xi-top></xi-top>
        <div class="banner-out-wrapper">
            <img :src="`${IMG_HOST}copyright_banner_bg.png`">
            <div class="banner-inner-wrapper">
                <div class="content">
                    <span class="large-slogan">持续获得影响力和收益</span>
                    <span class="sub-slogan">让你的作品插上声音的翅膀</span>
                    <!--<router-link v-if="$store.state.user.author.authorProgressStatus === 0" :to="{name: 'copyrighterApply'}">立即入驻</router-link>-->
                    <a class="btn-join" :href="$store.state.DUB_HOST" v-if="$store.state.user.author.authorProgressStatus === 0">立即入驻</a>
                    <span style="color: white;" v-if="$store.state.user.author.authorProgressStatus === 1">您的资料正在审核中....</span>
                    <div v-if="$store.state.user.author.authorProgressStatus === 5" class="rejoin-wrapper">
                        <router-link :to="{name: 'copyrighterApply'}">重新入驻</router-link>
                        <el-tooltip placement="bottom" effect="light">
                            <div slot="content">{{$store.state.user.author.rejectionReason}}</div>
                            <span class="rejection-reason">查看审核失败原因</span>
                        </el-tooltip>
                    </div>

                </div>
            </div>
        </div>
        <div class="production-flow-out-wrapper">
            <div class="production-flow-bg-wrapper">
                <div class="production-flow-inner-wrapper">
                    <span class="title">获得长期收益</span>
                    <div class="production-flow-wrapper">
                        <div class="production-flow">
                            <i class="icon icon-prod-flow-01 icon-28"></i>
                            <div>
                                <p class="title">作品销售分成</p>
                                <p class="desc">你将获得有声作品产生的销售分成，让作品时刻赚钱</p>
                            </div>
                        </div>
                        <div class="production-flow">
                            <i class="icon icon-prod-flow-02 icon-28"></i>
                            <div>
                                <p class="title">广告收入分成</p>
                                <p class="desc">平台会引入多种广告模式，让你持续获得广告收入分成</p>
                            </div>
                        </div>
                        <div class="production-flow">
                            <i class="icon icon-prod-flow-03 icon-28"></i>
                            <div>
                                <p class="title">流量红利</p>
                                <p class="desc">喜马拉雅FM拥有4亿用户，在强大的流量带动下，你的纸书、电子书和周边产品将一同获利</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="enter-out-wrapper">
            <div class="enter-inner-wrapper">
                <span class="title">简单三步轻松入驻</span>
                <div class="enter-flow">
                    <div class="flow">
                        <img :src="`${IMG_HOST}register_logo.png`">
                        <span class="content">1 注册账户</span>
                    </div>
                    <img :src="`${IMG_HOST}next_logo.png`">
                    <div class="flow">
                        <img :src="`${IMG_HOST}info_logo.png`">
                        <span class="content">2 提交资料</span>
                    </div>
                    <img :src="`${IMG_HOST}next_logo.png`">
                    <div class="flow">
                        <img :src="`${IMG_HOST}pass_audit_logo.png`">
                        <span class="content">3 通过审核</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="ad-out-wrapper">
            <div class="ad-inner-wrapper">
                <span class="title">他们已经在平台上获得了巨大的影响力和收益</span>
                <div class="items">
                    <div class="item">
                        <img src="http://fdfs.xmcdn.com/group11/M0A/CB/C0/wKgDa1aDNfbCQ0F-AAQuYGPWMgM050.jpg">
                        <span class="title">首席医官</span>
                        <span class="author">银河九天 著</span>
                        <span class="desc">专辑累计播放量 5.4亿</span>
                    </div>
                    <div class="item">
                        <img src="http://fdfs.xmcdn.com/group23/M01/15/2B/wKgJL1gYYjzxW7fQAAWaMAvliP8961.jpg">
                        <span class="title">摸金天师</span>
                        <span class="author">风尘散人 著</span>
                        <span class="desc">专辑累计播放量11.5亿</span>
                    </div>
                    <div class="item">
                        <img src="http://fdfs.xmcdn.com/group18/M04/C5/14/wKgJJVfDl-GS-CPPAAUbRT3EQ6A771.jpg">
                        <span class="title">雪中悍刀行</span>
                        <span class="author">烽火戏诸侯 著</span>
                        <span class="desc">专辑累计播放量1.6亿</span>
                    </div>
                    <div class="item">
                        <img src="http://fdfs.xmcdn.com/group8/M05/C8/8D/wKgDYVZqgCKRiQk1AAdB3O60pYc894.jpg">
                        <span class="title">侯卫东官场笔记</span>
                        <span class="author">小桥老树 著</span>
                        <span class="desc">专辑累计播放量3.5亿</span>
                    </div>
                </div>
            </div>
        </div>
        <xi-footer></xi-footer>
    </div>
</template>
<script>
    import axios from 'axios';
    import XiFooter from '../components/Footer.vue';
    import XiTop from '../components/Top.vue';
    export default {
        components: {
          axios,
          XiFooter,
          XiTop
        },
        data() {
            return {

            }
        },
        methods: {
          setXMLog () {
            xmLog('pv.create', {
              item: "有声化平台首页"
            })
          },
          getAuth () {
            xmLog("pv.send", "event", {
              serviceId: "aBookPageClick",
              srcPage: "有声化平台首页",
              srcModule: "我有作品",
              item: "button"
            });
            this.$router.push({
              name: 'copyrighterApply'
            });
          }
        },
        computed: {
          IMG_HOST(){
            return this.$store.state.IMG_HOST;
          }
        }
    }

</script>
<style lang="sass" scoped>
    @import "../../sass/copyright/index.scss";
    @import "../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// CopyrightIndex.vue?1b65aacc